module.exports = __webpack_public_path__ + "img/cement_white_grey_ba_list.84db7bdb.jpg";